import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
} from "@material-ui/core";
// import {appHelpers} from "../../_helpers";
import { EmptyRecord } from "../../utils/PageUtility";
import RecordPagination from "../../utils/RecordsPagination";
import Button from "components/CustomButtons/Button.jsx";
import CheckIcon from "@material-ui/icons/DoneAll";
import CancelIcon from "@material-ui/icons/Cancel";
import BackIcon from "@material-ui/icons/ArrowBack";
import ForwardIcon from "@material-ui/icons/ArrowForward";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CircularProgress from "../../utils/CircularProgress";
// import AddedPassengers from './AddedPassengers';
import ExtraPassengers from './ExtraPassengers';

import { appHelpers } from "../../_helpers";
import { connect } from "react-redux";
import Tooltip from '@material-ui/core/Tooltip';
import { appConstants } from "../../_constants";


const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    paragraph: {
        color: '#999999',
        fontFamily: 'Poppins',
        textAlign: 'left',
        margin: 0,
        fontSize: '0.85em'
    },
    heading: {
        color: '#3C4858',
        fontFamily: 'Poppins',
        textAlign: 'left',
        margin: 0
    },
    headerContainer: {
        display: 'flex',
        padding: '10px 0',
        justifyContent: 'space-around'
    }
};

const TableStructure = ({ classes, records, pageIndex }) => (
    <Table className={classes.table} aria-labelledby="tableTitle">
        <TableHead className={classes.negativeColor} color="primary">
            <TableRow>
                <TableCell>S/N</TableCell>
                <TableCell>Ticket Number</TableCell>
                <TableCell>Ticket Type</TableCell>
                <TableCell>Ticket Class</TableCell>
                <TableCell>Billlable</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {records.map((item, key) => {
                return (
                    <TableRow hover key={key}>
                        <TableCell component="th">{pageIndex + key}</TableCell>
                        <TableCell component="th">{item.TicketNo}</TableCell>
                        <TableCell>{item.PassengerType}</TableCell>
                        <TableCell>{item.TicketClass}</TableCell>
                        <TableCell>
                            {
                                item.IsBillable &&
                                <Tooltip title="Billable Passenger" placement="left-start">
                                    <Button color={'primary'} size={'sm'} justIcon={true} round={true} >
                                        <CheckIcon />
                                    </Button>
                                </Tooltip>
                            }
                            {
                                !item.IsBillable &&
                                <Tooltip title="Not Billable Passenger" placement="left-start">
                                    <Button color={'danger'} size={'sm'} justIcon={true} round={true} >
                                        <CancelIcon />
                                    </Button>
                                </Tooltip>
                            }
                        </TableCell>
                    </TableRow>
                );
            })}

        </TableBody>
    </Table>
);

function FlightNumberTable(props) {
    let { classes,
        fetchPassengers,
        flightPassengers,
        flightPassengerCount, activeFlight,
        pageSize, currentPage,
        handleChange, addPassenger, addedPassengers,
        TicketClass, TicketNumber, PassengerType,
        removePassenger, showPassengerForm, handleShowPassengerForm,
        requesting, userRole, generatePassengers, AdultPassengers,
        ChildPassengers, InfantPassengers } = props;


    const pageIndex = (pageSize * (currentPage - 1)) + 1;
    return (
        <div>
            <Card>
                <CardHeader color="success" stats icon>
                    <div style={styles.headerContainer}>
                        <div style={styles.paragraph}>
                            <p style={styles.paragraph}>
                                Airline
                        </p>
                            <h4 style={styles.heading}>
                                {activeFlight.Airline}
                            </h4>
                        </div>
                        <div style={styles.paragraph}>
                            <p style={styles.paragraph}>
                                Flight Number
                        </p>
                            <h4 style={styles.heading}>
                                {activeFlight.FlightNo}
                            </h4>
                        </div>
                        <div style={styles.paragraph}>
                            <p style={styles.paragraph}>
                                Departure Date
                        </p>
                            <h4 style={styles.heading}>
                                {appHelpers.formatDate(
                                    activeFlight.DepartureDate,
                                    "MMM DD, YYYY"
                                )}
                            </h4>
                        </div>
                        <div style={styles.paragraph}>
                            <p style={styles.paragraph}>
                                Passengers
                        </p>
                            <h4 style={styles.heading}>
                                <Tooltip title="Billable Passengers" placement="left-start">
                                    <span style={{ cursor: 'pointer' }}>
                                        {appHelpers.numberWithCommasOnly(activeFlight.BillablePassenger)}
                                    </span>
                                </Tooltip>
                                &nbsp; / &nbsp;
                            <Tooltip title="Total Passengers" placement="right-start">
                                    <span style={{ cursor: 'pointer' }}>
                                        {appHelpers.numberWithCommasOnly(activeFlight.PassengerCount)}
                                    </span>
                                </Tooltip>
                            </h4>
                        </div>
                    </div>
                </CardHeader>

            </Card>
            {showPassengerForm && userRole === appConstants.ROLES.VGG_ADMIN
                && <Button style={{ float: 'right' }} type="button"
                    color="transparent"
                    size={"sm"}
                    onClick={handleShowPassengerForm}>
                    <BackIcon /> Back to Passenger List
                 </Button>
            }
            {!showPassengerForm && !requesting && flightPassengerCount === 0
                && userRole === appConstants.ROLES.VGG_ADMIN &&
                <Button style={{ float: 'right' }} type="button"
                    color="info"
                    size={"sm"}
                    onClick={handleShowPassengerForm}>
                    Add passengers &nbsp;<ForwardIcon />
                </Button>
            }
            {
                !showPassengerForm && requesting &&
                <CircularProgress />
            }

            {
                !showPassengerForm && !requesting && flightPassengerCount > 0 &&
                <div className={classes.tableResponsive} style={{ overflowX: "scroll", overflowY: "visible" }}>
                    {!showPassengerForm && userRole === appConstants.ROLES.VGG_ADMIN &&
                        <Button style={{ float: 'right' }} type="button"
                            color="info"
                            size={"sm"}
                            onClick={handleShowPassengerForm}>
                            Add passengers &nbsp;<ForwardIcon />
                        </Button>
                    }
                    <RecordPagination fetchMore={fetchPassengers} totalCount={activeFlight.PassengerCount}
                        pageSize={pageSize} currentPage={currentPage}
                        target={<TableStructure pageIndex={pageIndex} records={flightPassengers} classes={classes} />}
                    />
                    {/*<TableStructure records={flightPassengers} classes={classes}/>*/}
                </div>
            }
            {
                !showPassengerForm && !requesting && flightPassengerCount === 0 &&
                <EmptyRecord message={'No Passenger record for flight.'} />
            }

            {
                showPassengerForm && userRole === appConstants.ROLES.VGG_ADMIN &&
                <ExtraPassengers
                    classes={classes}
                    handleChange={handleChange}
                    passengers={addedPassengers}
                    removePassenger={removePassenger}
                    addPassenger={addPassenger}
                    generatePassengers={generatePassengers}
                    TicketClass={TicketClass}
                    TicketNumber={TicketNumber}
                    PassengerType={PassengerType}
                    AdultPassengers={AdultPassengers}
                    ChildPassengers={ChildPassengers}
                    InfantPassengers={InfantPassengers}
                />
            }

        </div>
    );
}

function mapStateToProps(state, ownProps) {
    const { requesting } = state;
    return {
        requesting,
    };
}
// export default withStyles(styles)(FlightNumberTable);
export default connect(mapStateToProps)((withStyles(styles)(FlightNumberTable)));



// WEBPACK FOOTER //
// ./src/views/AirlinesPassenger/PassengersTable.jsx